<template>
    <div id="error"
    :style="{background: 'url(' + allImageMap.bg + ') no-repeat'}">
        <div>
            <transition name="fade" enter-active-class="animated bounceIn" :duration="200">
                <div class="codeIndexDialogMask">
                <div
                    class="adoptDialog failDialog adoptDialog_en"
                    :style="{background: 'url(' + allImageMap.popWin_03 + ') no-repeat'}"
                >
                    <!-- 失败弹窗标题 范围 -->
                    <div class="failDialogTitle">
                    <!-- 失败弹窗标题 文字 -->
                    <div class="failDialogTitle_txt" :dir="dirLang" >{{$t('message.retry')}}</div>
                    </div>
                    <!-- 失败弹窗内容 范围 -->
                    <div class="failDialogContent">
                    <!-- 失败弹窗内容 文字 -->
                    <div class="failDialogContent_txt" :dir="dirLang">{{$t('message.jump_error')}}</div>
                    </div>
                    <div
                    class="adoptLeftBtn failAcceptClick"
                    :style="{background: 'url(' + allImageMap.popWin_10 + ') no-repeat'}"
                    @click="failAcceptClick"
                    ></div>
                </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
import store from "../store";
import { mapGetters } from "vuex";
import AdventureManager from "../manager/AdventureManager";
export default {
    data() {
        return {

        }
    },
    mounted() {
        let lan =  AdventureManager.getQueryString("zhOren");
        if (lan == 'ar' || lan == 'he') store.state.dirLang = 'rtl';
        else store.state.dirLang = 'ltr'
        console.log(store.state.dirLang)
    },
    methods: {
        failAcceptClick(){
            window.location.href = 'about:blank';
            window.close();
        }
    },
    computed: {
        ...mapGetters(["allImageMap",'dirLang'])
    },
}
</script>
<style lang="">
#error{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
.codeIndexDialogMask {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 2000;
}
.adoptDialog_en {
    width: 556px;
    height: 439px;
    /*margin-left: -278px;
    margin-top: -219.5px;*/
}
.adoptDialog {
    box-sizing: border-box;
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 2000;
	transform: translate(-50%,-50%);
}
.failDialogTitle {
    position: absolute;
    width: 249px;
    height: 72px;
    left: 151px;
}
.failDialogTitle_txt {
    position: absolute;
    width: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    line-height: 24px;
    color: #fafafa;
    font-size: 24px;
    font-weight: bold;
}
.failDialogContent {
    position: absolute;
    left: 50px;
    right: 50px;
    top: 90px;
    bottom: 150px;
}
.failDialogContent_txt {
    position: absolute;
    width: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    line-height: calc(19px * 1.5);
    color: #fafafa;
    font-weight: bold;
    font-size: 19px;
}
.failAcceptClick{
    width: 182px;
    right: 185px;
    bottom: 25px;
    height: 87px;
}
.adoptLeftBtn {
    position: absolute;
    cursor: pointer;
}
@media (max-height: 420px) and (orientation: landscape) {
	.adoptDialog {
		transform: translate(-50%,-50%) scale(.6) !important;
	}
	.successDialog {
		transform: translate(-50%,-50%) scale(.4) !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/errorMsg.vue